export default {
  numericDateDisplay: 'M.DD.YY',
  fullNumericDateDisplay: 'M.DD.YY h:mm',
  dateString: 'YYYY-MM-DD',
  dateStamp: 'YYYY-MM-DD HH:mm',
  fullTextDate: 'MMMM, D YYYY',
  defaultDuration: 'HH:mm:ss'
};